'use client'

import * as React from 'react'
import * as LabelPrimitive from '@radix-ui/react-label'
import {cva, type VariantProps} from 'class-variance-authority'
import {cn} from '../utils/cn'

const defaultLabelVariants = cva(
  'text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
)

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
    VariantProps<typeof defaultLabelVariants>
>(({className, ...props}, ref) => {
  return (
    <LabelPrimitive.Root
      data-sr-label=""
      ref={ref}
      className={cn(defaultLabelVariants(), className)}
      {...props}
    />
  )
})
Label.displayName = LabelPrimitive.Root.displayName

export {Label, defaultLabelVariants}
